import _scrollIntoView from 'smooth-scroll-into-view-if-needed';

export const scrollIntoView =
  _scrollIntoView as unknown as typeof _scrollIntoView.default;
